import {DialogTitle} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import React, {useState} from "react";
import {ICharInventarSpell} from "../../_interfaces/ICharInventarSpell";
import {v4} from "uuid"
import {s_char, s_char_inventarSpells} from "../../_signals/s_char";
import {InventarSpellsCreate} from "../../_api/BEInventarSpells";
import TextField from "@mui/material/TextField";
import {SpellsSubscriber} from "../../_helper/DataBehaves";

interface IProp {
    open: boolean,
    isOpen: (open: boolean) => void
}
export default function DialogAddInventar({open, isOpen}: IProp) {

    const [inventarSpell, setInventarSpell] = useState('')
    const [note, setNote] = useState('')

    const addInventarSpell = () => {
        const spell = SpellsSubscriber.value.find(s => s.name === inventarSpell)
        if (spell) {
            const inventar: ICharInventarSpell = {
                attunediff: spell.attune,
                castdiff: spell.casting,
                cid: s_char.value.id,
                circle: spell.circle,
                discipline: spell.discipline,
                id: v4(),
                name: spell.name,
                threads: spell.threads,
                weavediff: spell.weaving,
                note: note

            }
            InventarSpellsCreate(inventar)
            s_char_inventarSpells.value = [...s_char_inventarSpells.value, inventar]
        }
        isOpen(false)
    }

    return <Dialog open={open}>
        <DialogTitle>Spruch eintragen</DialogTitle>
        <DialogContent>
            <Select value={inventarSpell ?? ''}
                    style={{width: "100%"}}
                    onChange={(e) => setInventarSpell(e.target.value)}
                    variant="standard"
            >
                {SpellsSubscriber.value.map(spell => <MenuItem key={v4()} value={spell.name}>
                    Kreis: {spell.circle} {spell.discipline} {spell.name}
                </MenuItem>)}
            </Select>
            <TextField multiline maxRows={3} value={note} onChange={(e) => setNote(e.target.value)}></TextField>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => addInventarSpell()}>eintragen</Button>
            <Button onClick={() => isOpen(false)}>beenden</Button>
        </DialogActions>
    </Dialog>
}